import { RelatedApps, RELATED_BY_APP } from '@hypneuronerd/ui';
import type { Dose, Recommendation } from '../data/types';
import { DOSE_DESCRIPTIONS, DOSE_LABELS } from '../data/types';
import styles from './ResultPanel.module.css';

interface ResultPanelProps {
  recommendation: Recommendation;
  reasoningParagraphs: string[];
}

export function ResultPanel({ recommendation, reasoningParagraphs }: ResultPanelProps) {
  const { dose, confidence, warnings } = recommendation;
  const certainty =
    confidence > 0.7 ? 'high' : confidence > 0.4 ? 'moderate' : 'borderline';

  return (
    <section className={styles.panel} aria-live="polite">
      <header className={styles.header}>
        <p className={styles.label}>recommendation</p>
        <h2 className={styles.dose}>{DOSE_LABELS[dose]}</h2>
        <p className={styles.shape}>{DOSE_DESCRIPTIONS[dose]}</p>
        <p className={styles.certainty}>certainty: {certainty}</p>
      </header>

      <div className={styles.body}>
        {reasoningParagraphs.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>

      {warnings.length > 0 && (
        <aside className={styles.warnings} aria-label="watch for">
          <p className={styles.warningsHead}>watch for</p>
          <ul>
            {warnings.map((w, i) => (
              <li key={i}>{w}</li>
            ))}
          </ul>
        </aside>
      )}

      <RelatedApps apps={RELATED_BY_APP['dose-calibrator']} surface="midnight" />
    </section>
  );
}
